// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"loading-module--wrapper--1yZGC","ldsRoller":"loading-module--lds-roller--3YZ17"};